export * from './CustomizationDetailsDressingPortionV2';
